import React, { useState, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { MultiMsg, OpStatus, DmsConfig, Font } from 'NSwag/ServerClient/Client.nswag';
import MultiMsgPhaseDisplay from 'Common/Controls/Dms/MultiMsg/MultiMsgDisplay/MultiMsgPhaseDisplay';
import { Message, IMessageUpdate } from 'Common/Controls/Dms/MultiMsg/Message';
import { Phase, IPhaseUpdate } from 'Common/Controls/Dms/MultiMsg/Phase';
import { areTagsSupported } from 'Common/Controls/Dms/MultiMsg/MultiUtils';
import { setTimeout, clearTimeout } from 'timers';
import { IFonts } from 'Store/index';
import MultiMsgImageDisplay from './MultiMsgDisplay/MultiMsgImageDisplay';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'block',
    }
}))

export interface IProps {
    multiMsg: MultiMsg;
    opStatus: OpStatus;
    dmsConfig?: DmsConfig;
    font: Font | null;
}

const MultiMsgDisplay: React.FC<IProps> = ({ multiMsg, opStatus, dmsConfig, font }: IProps) => {

    const classes = useStyles();

    const [message, setMessage] = useState<Message | null>(null);
    const [phaseValues, setPhaseValues] = useState<string[][]>([]);
    const [activePhase, setActivePhase] = useState<number>(0);
    const [supported, setSupported] = useState<boolean>(false);

    const handleMessageUpdate = (update: IMessageUpdate) => {
        setPhaseValues(update.phases.map(phase => phase.toStrings()));
    }

    useEffect(() => {
        let supported = areTagsSupported(multiMsg.msgText!);
        setSupported(supported);
        if (supported) {
            let message = new Message({
                onChange: handleMessageUpdate,
                dmsConfig,
                font
            });

            message.parseMultiMsg(multiMsg.msgText!);
            setMessage(message);
            setActivePhase(0);
        }
    }, [multiMsg, dmsConfig, font]);

    useEffect(() => {
        if (message) {
            setPhaseValues(message.phases.map(phase => phase.toStrings()));
        }
    }, [message]);

    useEffect(() => {
        if (message && message.phases[activePhase]) {
            let phase = message.phases[activePhase];

            let onTime = phase.onTime * 100;
            const timer = setTimeout(() => {
                blankPhase(phase);
            }, onTime);

            return () => clearTimeout(timer);
        }
    }, [message, activePhase]);

    const blankPhase = (phase: Phase) => {
        let offTime = phase.offTime * 100;
        const timer = setTimeout(() => {
            let nextPhase = activePhase + 1 < message!.phases.length
                ? activePhase + 1
                : 0;
            if (nextPhase !== activePhase) {
                setActivePhase(nextPhase);
            }
            clearTimeout(timer);
        }, offTime);
    }

    return (
        <div className={classes.container} >
            {
                supported && message && phaseValues[activePhase] && message.phases[activePhase] &&
                <MultiMsgPhaseDisplay
                    value={phaseValues[activePhase]}
                    phase={message.phases[activePhase]}
                    opStatus={opStatus}
                    onShiftFocus={() => { /* display only, will never fire */ }}
                    focused={null}
                    editable={false}
                />
            }
        </div>
    );
}

export default MultiMsgDisplay;
